import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { DataFichaRegistro } from 'app/models/fichaRegistro.model';
import { ProcedenciaInterface } from 'app/models/procedencia.model';
import { Observable, Subject, takeUntil } from 'rxjs';
import { DetalleBienCulturalService } from '../../detalle-bien-cultural.service';
import { ActivatedRoute } from '@angular/router';
import { UtilsService } from 'app/modules/utils-service';

@Component({
    selector: 'info-procedencia',
    templateUrl: 'procedencia.component.html',
    imports:[
        FormsModule,CommonModule, MatButtonModule
    ]
})

export class InfoProcedenciaComponent implements OnInit {
    informacionFichaRegistro$:Observable<DataFichaRegistro>
    procedencia:ProcedenciaInterface = new ProcedenciaInterface(null)
    uu_id: string;
    
    private destroy$ = new Subject<void>();
    
    constructor(
        private detalleBienesService:DetalleBienCulturalService,
        private route:ActivatedRoute,
        private utilsService:UtilsService
    ) {
        this.uu_id = this.route.snapshot.paramMap.get('uu_id')!;
     }

    ngOnInit() { 
        this.informacionFichaRegistro$ = this.detalleBienesService.fichaRegisto$;
         this.informacionFichaRegistro$
        .pipe(takeUntil(this.destroy$))
        .subscribe(ficha => {
            if (ficha?.bienCultural) {
            this.procedencia = {
                epoca: ficha.bienCultural.epoca,
                periodo: ficha.bienCultural.periodo,
                fase: ficha.bienCultural.fase,
                anio: ficha.bienCultural.anio,
                tipoEstilo: ficha.bienCultural.tipoEstilo,
                procedencia: ficha.bienCultural.procedencia,
                formaAdquisicion: ficha.bienCultural.formaAdquisicion,
                tradicion: ficha.bienCultural.tradicion,
                autor:ficha.bienCultural.autor,
                constructorTexto:ficha.bienCultural.constructor,
                informante:ficha.bienCultural.informante
            };
            }
        });
    }

    actualizarProcedencia(){
        this.detalleBienesService.putInfoProcedencia(this.uu_id, this.procedencia)
        .then((response:any) =>{
            this.utilsService.openSuccessSnakBar(response.message)
            this.detalleBienesService.getBitacoraBienes(this.uu_id)
        })
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}